<style lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import PageOffer
</style>

<script>

    import Newsfeed from '../../common/components/Newsfeed.vue'

    export default {
        components: {
            Newsfeed
        },
        setup(){
          return { Newsfeed }
        }

    }

</script>
